import ReactDOM from 'react-dom';
import { setKeycloakInstance } from './config/keycloak';
import { getTenant, getkeycloakClientName } from './utils/getKeycloakConfig';
import './styles/main.less';
import axios from 'axios';
import Keycloak from 'keycloak-js';
import RootElement from './RootElement';
import { configUrl, getPreferredConfig, setConfig } from './config/config';
import { GlobalConfiguration } from './constants/types';

const setAndGetPreferredConfig = async (data: GlobalConfiguration) => {
  const preferredConfig = await getPreferredConfig(data as GlobalConfiguration);
  await setConfig(preferredConfig);
  return preferredConfig;
};

const setupKeycloakInstance = async (config: {
  url: string;
  realm: string;
  clientId: string;
}) => {
  const instance = await new Keycloak(config);
  await setKeycloakInstance(instance);
  return instance;
};

axios
  .get(configUrl())
  .then(async response => {
    const preferredConfig = await setAndGetPreferredConfig(
      response.data as GlobalConfiguration,
    );
    const instance = await setupKeycloakInstance({
      url: `${preferredConfig.keycloakApiEndpoint}/auth`,
      realm: `${getTenant() || preferredConfig.defaultTenant}`,
      clientId: `${
        getkeycloakClientName() || preferredConfig.keycloakClientName
      }`,
    });
    ReactDOM.render(
      <RootElement keycloakInstance={instance} />,
      document.getElementById('root'),
    );
  })
  .catch(async () => {
    const preferredConfig = await setAndGetPreferredConfig(
      {} as GlobalConfiguration,
    );
    const instance = await setupKeycloakInstance({
      url: `${preferredConfig.keycloakApiEndpoint}/auth`,
      realm: `${getTenant() || preferredConfig.defaultTenant}`,
      clientId: `${
        getkeycloakClientName() || preferredConfig.keycloakClientName
      }`,
    });
    ReactDOM.render(
      <RootElement keycloakInstance={instance} />,
      document.getElementById('root'),
    );
  });
